/* Klon-Logik: ersetzt die Teile, die im Original von Shopify-Apps kommen. */
(function () {
  'use strict';

  /* Paket-Auswahl (im Original: Kaching Bundles) */
  var bars = document.querySelectorAll('.kaching-bundles__bar');
  if (!bars.length) return;

  function select(bar) {
    bars.forEach(function (b) {
      b.classList.toggle('kaching-bundles__bar--selected', b === bar);
      var radio = b.querySelector('input[type="radio"]');
      if (radio) radio.checked = b === bar;
    });
    document.dispatchEvent(new CustomEvent('clone:bundle-change', {
      detail: { id: bar.getAttribute('data-deal-bar-id') }
    }));
  }

  bars.forEach(function (bar) {
    bar.addEventListener('click', function (e) {
      if (e.target.closest('a')) return; // Gratis-Produkt-Link nicht abfangen
      e.preventDefault();
      select(bar);
    });
    bar.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        select(bar);
      }
    });
  });

  /* Vorauswahl aus dem Markup übernehmen */
  var pre = document.querySelector('.kaching-bundles__bar--selected') || bars[0];
  select(pre);
})();
